/* globals dataLayer, adobe */
(function (window, angular, undefined) {
angular.module('formApp')
.controller('retrieveEcoverController', ['$scope', 'FormService', 'updateHeader', 'formData', '$state', 'errorHandler', 'LoadingInterceptor', 'sessionService', '$location', '$rootScope', 'dataLayerService','$q','$timeout', 'scrollToPoint',
function ($scope, formService, updateHeader, formData, $state, errorHandler, loadingInterceptor, sessionService, $location, $rootScope, dataLayerService,$q,$timeout, scrollToPoint) {

$scope.straightThroughValidation = false;
// for old page a/b test
if ($location.path() === '/ecover/retrieve-2') {
    var adobeTestKey = 'Old ecover retrieve page';
    var adobeTestvalue = 'experienceB';

    if (!window.sessioncamConfiguration) {
        window.sessioncamConfiguration = {};
    }
    if (!window.sessioncamConfiguration.customDataObjects) {
        window.sessioncamConfiguration.customDataObjects = [];
    }
    var sessioncamItem = {
        key: adobeTestKey,
        value: adobeTestvalue
    };
    window.sessioncamConfiguration.customDataObjects.push(sessioncamItem);

    window.dataLayer = window.dataLayer || [];
   
}

sessionService.stop();

//$scope.dobDateMin = moment().format('YYYY-MM-DD');species
//$scope.dobDateMax = moment().subtract(99, 'year').format('YYYY-MM-DD');
$scope.activateCover = {};

var refNo = $location.search().RefNo;
if (refNo) {
    $scope.activateCover.quoteRef = parseInt(refNo, 10);
}

$scope.formData = formData;
updateHeader.petType = 'default';

var petName = $location.search()['petName'];
if(petName){
    var lastChar = petName[petName.length - 1];
    var sChar ="\'s";  
    
    console.log(lastChar);
    if (lastChar === 's') {
        $scope.petName = petName + "\'";
    }
    else if (lastChar === undefined){
        sChar=null;
        console.log(sChar);
    }
    else{
        $scope.petName = petName+ sChar;   
    }
}

angular.forEach($location.search(), function (value, key) {
    var keyName = key.toLowerCase();
    var petSpecies = value.toLowerCase();
    if (keyName === 'species') {
        if (petSpecies === 'dog' || petSpecies === 'cat' || petSpecies === 'rabbit') {
            updateHeader.petType = petSpecies;
            $scope.species = "your " + petSpecies+'\'s'; 
        } else if (petSpecies === 'multipet') {
            updateHeader.petType = 'multipet';
            $scope.species = "your pets";
        }
        else {
            updateHeader.petType = 'default';
            $scope.species = "your pet's"; 
        }
    }
});

var trustboxRef = document.getElementById('trustbox');
if(trustboxRef && window.Trustpilot){
    window.Trustpilot.loadFromElement(trustboxRef);
}

//straight throuh validation logic
var params = {}, encryptedParams = getUrlParameter('encryptedParams'), parisRef = getUrlParameter('RefNo');
$scope.straightThroughValidation = encryptedParams !== '' ? true : false;

angular.element(document).ready(function () {
    if (encryptedParams !== '') {
        params = {
            encryptedParams: encryptedParams,
            parisRef: parisRef
        };
        loadingInterceptor.incrementRequests();
        setTimeout(function () {
            getQuoteDetails(params);
            loadingInterceptor.decrementRequests();
        }, 2000);
    }
});

function getUrlParameter(name) {
    name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
    var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
    var results = regex.exec(location.search);
    return results === null ? '' : decodeURIComponent(results[1]).replace(/ /g,'+');
}

$scope.$watch('gatewayReady', function (newVal, oldVal) {
    if (newVal === true) {
        dataLayer.push({
            'event': 'dataAvailable',
            'funnelName': parseInt(dataLayerService.setFunnelName()),
            'funnelVersion': '1.0',
            'funnelPageNumber': 1,
            'environment': window.location.hostname,
            'bravCode': '',
            'campaignCode': ''
        });
    }
});

$scope.submit = function () {
    var params;
    if($rootScope.altRetrieveEcover){
        params = {
                email: $scope.activateCover.email,
                petName: $scope.activateCover.pet,
                postCode: $scope.activateCover.postCode,
            };
        }
        else{

        params = {
            parisRef: $scope.activateCover.quoteRef,
            postCode: $scope.activateCover.postCode,
            //dob: $scope.activateCover.dob
        };
    }
    getQuoteDetails(params);
};

//STV logic split
function getQuoteDetails(params) {
    var application;

    loadingInterceptor.incrementRequests();
    formService.getQuote(params).then(
        function (response) {
            sessionStorage.setItem('eCoverNote', 'true');
            sessionStorage.removeItem('eQuote');
            sessionStorage.removeItem('eCoverJourney');

            formService.setApplicationId(response.data.uri.split('/').pop());
            formService.setQuoteExpiry(response.data.isQuoteExpired);
            return formService.getApplication();
    }
).then(
    function(response) {
            application = response.data;

            // Setting isSpecialBreed flag for redirection
            $scope.isSpecialBreed = false;
            $scope.pet= response.data.application.pets[0];
            $scope.petDetails =response.data.application.pets[0].details;

            //Proceed only if single breed
            if ($scope.petDetails.pedigreeBreed) {
                $scope.searchConstraints = $scope.$parent.$parent.schema.types.dog.details.breedOne.constraints;

                var modelValue, breedList;

                angular.forEach( $scope.searchConstraints, function (value, key) {
                    modelValue = $scope.petDetails.pedigreeBreed;
                    breedList = value.values;
                    if (value && modelValue && breedList.indexOf(modelValue) !== -1) {
                        $scope.index = breedList.indexOf(modelValue);
                        $scope.pet = $scope.pet;
                        $scope.isSpecialBreed = true;
                    }
                });
            }

            // reset any existing campaign info
            $scope.$parent.campaign = '';
            $scope.$parent.brav = '';
            sessionStorage.removeItem('campaign');
            sessionStorage.removeItem('brav');

            if (application.officeUseOnly && application.officeUseOnly.params) {
                if ($scope.isSpecialBreed) {
                    triggerSpecialListBreedPopup();
                }
                else {
                    $scope.$parent.campaign = application.officeUseOnly.params.campaign;
                    sessionStorage.setItem('campaign', $scope.$parent.campaign);

                    $scope.$parent.brav = application.officeUseOnly.params.brav;
                    sessionStorage.setItem('brav', $scope.$parent.brav);

                    // identi offer pre
                    if($scope.$parent.campaign === 'IDTALERT') {
                        $scope.$parent.idt = 'true';
                    } else {
                        $scope.$parent.idt = 'false';
                    }
                }

            }

            populateFormData(application);
            
            loadingInterceptor.decrementRequests();

            sessionService.start();
            if(sessionStorage.getItem('isQuoteExpired') === 'Y') {
                sessionStorage.setItem('currentRefreshState', 'retrieve-expired');
                    // Quick fix remove before live//
                var env = window.location.hostname;

                if (env.search('petplan.co.uk') !== -1 || env.search('azuk.cloud') !== -1) {
                    window.location.href='/retrieve-expired';
                }
                else {
                    window.location.href='/content/ah_small-animal/index.html/retrieve-expired';
                }
                // Quick fix remove before live//
            }
            else if (!application.runningTotals) {
                $scope.searchConstraints = $scope.$parent.$parent.schema.types.dog.details.breedOne.constraints;

                // if Specialist Breed then show the pop up and redirect to ecover login screen
                if ($scope.isSpecialBreed) {
                    triggerSpecialListBreedPopup();
                } else {
                    sessionStorage.setItem('currentRefreshState', 'details-ec');
                    $state.go('details-ec', { forward: true });
                }
            } else {
                if (application.officeUseOnly.params.recognized === 'Y') {
                    sessionStorage.setItem('eCoverJourney', 'return-rec');
                } else {
                    sessionStorage.setItem('eCoverJourney', 'return');
                }
                sessionStorage.setItem('currentRefreshState', 'quote-ec');

                var step3State = 'quote';
                var i=0;
                
                step3State = 'quote';
                while (i < $scope.formData.pets.length -1 && $scope.formData.pets[i].chosenCover && $scope.formData.pets[i].chosenCover.productId && $scope.formData.pets[i].chosenCover.productLine) {
                    i++;
                }
                // console.log('i = ', i);
                if(!$scope.formData.pets[i].chosenCover) {
                    step3State = 'quote';
                } else {
                    step3State = 'quote';
                } 
                $state.go('quote-ec-select', {id: i, selectState: step3State, forward: true  });

            }
        }
    ).catch(
        function (error) {
            if (encryptedParams) {
                //if decryption fails redirect to normal retrieval rather than going to error screen
                encryptedParams = '';
                console.log("object");
                $scope.straightThroughValidation = false;
                errorHandler.reportErrors(error, 'decryptionFailed', 'retrieve-ec');
            }
            else {
                console.log("Activate ecover error");
                errorHandler.reportErrors(error, 'redirect', 'retrieve-ec');
            }
        }
    );
}

function triggerSpecialListBreedPopup (){
    loadingInterceptor.decrementRequests();
     // need timeout as delay in getting value
     $timeout(function () {
         $rootScope.$broadcast('SPECIAL.BREED.INDEX');
         scrollToPoint.scrollTo('specialistBreedModal', 20, 'id');
     }, 200);
}

function populateFormData(data) {
    $scope.formData.pets = data.application.pets;
    $scope.formData.aboutYou = data.application.aboutYou;
    $scope.formData.cover = data.application.cover;
}

if (typeof window.rTapNotifyDOMChange === "function") {
    window.rTapNotifyDOMChange(document.getElementById('skipnav'));
}

}]);
})(window, window.angular);